/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TeachingStaffViewModel } from "../types/TeachingStaffViewModel.ts";
import { eAcademicEducationSchema } from "./eAcademicEducationSchema.ts";
import { eUspContractTypeSchema } from "./eUspContractTypeSchema.ts";

export const teachingStaffViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  observation: z.string().nullish(),
  isUspTeaching: z.optional(z.boolean()),
  codeUSP: z.string().nullish(),
  certNumber: z.string().nullish(),
  uspContractType: z.optional(
    z
      .lazy(() => eUspContractTypeSchema)
      .describe("1 = RTC | 2 = RTP | 3 = RDIDP | 4 = Aposentado | "),
  ),
  academicEducation: z.optional(
    z
      .lazy(() => eAcademicEducationSchema)
      .describe(
        "1 = UndergraduateDegree | 2 = Technologist | 3 = PostgraduateDegree | 4 = MasterDegree | 5 = DoctorateDegree | 6 = BachelorDegree | 7 = HighSchool | 8 = Specialist | ",
      ),
  ),
  certWorkload: z.number().nullish(),
  certExpirationDate: z.string().datetime().nullish(),
  isLattes: z.optional(z.boolean()),
  lattesUpdateDate: z.string().datetime().nullish(),
}) as unknown as ToZod<TeachingStaffViewModel>;
